export default __webpack_public_path__ + "static/media/irp_montage.27406f52.jpg";